import CustomInput from 'components/common/CustomInput'
import { ISelectOption } from 'components/common/CustomSelect'
import { useEffect, useState } from 'react'
import CountryData from 'data/country.json'
import { ReactComponent as Reset } from 'assets/common/reset.svg'
import { formatDate } from 'components/function'
import CustomDatePicker from 'components/common/CustomDatePicker'
import { IListSearch, ISearchInfo } from 'types/issue'

const First = ({ searchInfo, setSearchInfo, init, blNo, title }: IListSearch) => {
    const [option, setOption] = useState<ISelectOption[]>([])
    const [dateReset, setDateReset] = useState<boolean>(false)

    useEffect(() => {
        const mapped: ISelectOption[] = CountryData.map(item => ({
            value: item.id || '',
            label: item.ko,
            labelEn: item.en
        }));
        setOption(mapped);
    }, [])

    const reset = () => {
        setSearchInfo({
            page: 1,
            pageSize: 10
        } as ISearchInfo);
        setDateReset(true)
    }

    return (
        <div className='bg-white rounded-lg'>
            <div className='flex items-center tablet:p-4 px-10 border-b-1 w-full h-20'>
                <p className='font-semibold tablet:text-lg text-2xl'>{title}</p>
            </div>
            <div className='flex tablet:flex-col gap-6 tablet:gap-4 tablet:p-4 px-10 py-6'>
                {/* 견적수락일 */}
                <div className='flex items-center gap-1 bg-[#F8F8FA] rounded'>
                    <CustomDatePicker
                        onChange={(value: Date | null | [Date | null, Date | null]) => {
                            if (Array.isArray(value) && value.every(v => v !== null)) {
                                const [start, end] = value;
                                setSearchInfo(p => ({
                                    ...p,
                                    fromDate: formatDate(start),
                                    toDate: formatDate(end),
                                    page: 1
                                }))
                            }
                            else if (Array.isArray(value) && value.every(v => v === null)) {
                                reset()
                            }
                        }}
                        isRange={true}
                        isMaxToday={true}
                        isReset={dateReset}
                        setIsReset={setDateReset}
                    />
                </div>

                <div className='w-[320px]'>
                    <CustomInput
                        type="text" height={15} fontSize={'sm'} placeholder="BL 넘버, 타이틀, 내용 검색어를 입력하세요"
                        value={searchInfo.search ?? ''}
                        onChange={(e) => {
                            setSearchInfo(p => ({
                                ...p,
                                search: e.target.value,
                                page: 1
                            }))
                        }}
                    />
                </div>

                {
                    Object.entries(searchInfo)
                        .filter(([key]) => key !== 'page' && key !== 'pageSize') // page 제외
                        .some(([, value]) => value !== '' && value !== null) && (
                        <div
                            className='group flex justify-center items-center border rounded-md w-15 tablet:w-10 h-15 tablet:h-10 overflow-hidden cursor-pointer'
                            onClick={reset}
                        >
                            <Reset className='group-hover:scale-120 transition-all' />
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default First